import { create } from "zustand";

// Zustand
type modelSelectorStore = {
  authOpen: boolean;

  setAuthOpen: (open: boolean) => void;
};

export const useLayoutStore = create<modelSelectorStore>()((set) => ({
  authOpen: false,

  setAuthOpen: (open: boolean) =>
    set((state) => {
      return { authOpen: open };
    }),
}));
